const campaingJobBlocks = document.querySelectorAll('.campaign-job-block')
const language = document.querySelector('html').getAttribute('lang')

campaingJobBlocks.forEach((jobBlock) => {
  const blockId = jobBlock.getAttribute('data-block-id')
  const loadMoreBtn = jobBlock.querySelector('.load-more-btn')
  const listingContainer = jobBlock.querySelector('.listing')
  const joblist = listingContainer.classList.contains('result-container') ? listingContainer : listingContainer.querySelector('.result-container')

  const getMore = async (url) => {
    listingContainer.classList.add('loading')
   
    await fetch(url, {
      method: "GET",
      headers:
      {
        "X-Requested-With": "XMLHttpRequest",
      }
    }).then(res => {
      if (!res.ok && res.status !== 404) {
        return Promise.reject(res);
      }
      return res.status !== 404 ? res.text() : null

    }).then(data => {
      if (!data) return null
      const parser = new DOMParser()
      return parser.parseFromString(data, "text/html")
    }).then((el) => {
      if (el) {
        el.querySelectorAll('.job-result').forEach((result) => joblist.appendChild(result))
        const newSkipCount = el.querySelector('.load-more-btn')?.getAttribute('data-skip')

        if (newSkipCount && loadMoreBtn) {
          loadMoreBtn.setAttribute('data-skip', newSkipCount)
          loadMoreBtn.classList.remove('d-none')
        }
        else {
          loadMoreBtn?.classList.add('d-none')
        }

      } else {
        loadMoreBtn?.classList.add('d-none')
      }

      listingContainer.classList.remove('loading')
    }).catch(error => {
      console.error(`Error from API: ${error.status}
        - ${error.statusText}`)
      listingContainer.classList.remove('loading')
    })
  }

  const loadmoreHandler = (event) => {
    const skipCount = event.target.getAttribute('data-skip')
    const url = `/loadcontentapi/jobs?contentid=${blockId}&language=${language}&skip=${skipCount}`
    getMore(url)
  }

  loadMoreBtn?.addEventListener('click', loadmoreHandler)
})